import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	user: {},
	error: "", // for error message
	loading: false,
	isUserLogout: false,
	errorMsg: false, // for error
	isMaintenance: false,
};

const loginSlice = createSlice({
	name: "Login",
	initialState,
	reducers: {
		/* eslint-disable require-jsdoc */
		apiError(state, action) {
			state.error = true;
			state.loading = true;
			state.isUserLogout = false;
			state.errorMsg = action.payload;
		},
		loginSuccess(state, action) {
			state.user = action.payload;
			state.loading = false;
			state.errorMsg = false;
		},
		logoutUserSuccess(state) {
			state.isUserLogout = true;
		},
		reset_login_flag(state) {
			state.error = false;
			state.loading = false;
			state.errorMsg = null;
		},
		resetLoginState(state) {
			state.user= {};
			state.error= ""; // for error message
			state.loading= false;
			state.isUserLogout= false;
			state.errorMsg= false; // for error
		},
		setIsMaintenance(state, action) {
      state.isMaintenance = action.payload;
    },
		/* eslint-enable require-jsdoc */
	},
});

export const {
	apiError,
	loginSuccess,
	logoutUserSuccess,
	reset_login_flag,
	resetLoginState,
	setIsMaintenance
} = loginSlice.actions;

export default loginSlice.reducer;